import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { TextKeys } from '../../../../core/i18n/text-keys';
import { SessionQuery } from '../../../../core/state-mangement/session/session.query';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-mail-pop-up',
  templateUrl: './mail-pop-up.component.html',
  styleUrls: ['./mail-pop-up.component.scss'],
})
export class MailPopUpComponent implements OnInit {
  @Input() message: string;
  @Input() deleteEvent: EventEmitter<void>;
  @Input() dontDeleteEvent: EventEmitter<void>;

  texts = TextKeys;
  email = new UntypedFormControl('');
  rows = 8;
  titleName$: Observable<string>;
  constructor(private query: SessionQuery, private modalController: ModalController) {}

  ngOnInit() {
    this.email.setValue(this.message);
    this.titleName$ = this.query.fullName$;
  }

  close() {
    this.modalController.dismiss().then(() => this.dontDeleteEvent.emit());
  }

  deleteEmail() {
    this.modalController.dismiss().then(() => this.deleteEvent.emit());
  }
}
